import { ANIMAL_DREAMS } from './animal';
import { NATURE_DREAMS } from './nature';
import { PERSON_DREAMS } from './person';
import { OBJECT_DREAMS } from './object';
import { ACTION_DREAMS } from './action';
import { PLACE_DREAMS } from './place';
import { BODY_DREAMS } from './body';
import { DEATH_DREAMS } from './death';

export const DREAM_DATA = {
  animal: ANIMAL_DREAMS,
  nature: NATURE_DREAMS,
  person: PERSON_DREAMS,
  object: OBJECT_DREAMS,
  action: ACTION_DREAMS,
  place: PLACE_DREAMS,
  body: BODY_DREAMS,
  death: DEATH_DREAMS,
};

export const getAllDreamCategories = () => Object.values(DREAM_DATA);

export const getDreamCategory = (categoryId) => DREAM_DATA[categoryId] || null;

export const getDreamSubject = (categoryId, subjectId) => {
  const category = DREAM_DATA[categoryId];
  if (!category) return null;
  return category.subjects.find(s => s.id === subjectId) || null;
};
